import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import { normalizedData } from "@utils";
import Seo from "@components/seo";
import Layout from "@layout";
import Header from "@layout/header/layout-01";
import Footer from "@layout/footer/layout-01";
import PageHeader from "@containers/page-header/layout-02";
import DentalServiceArea from "@containers/dental-service/layout-03";
import { useTranslation } from "@hooks";
import ContactArea from "@containers/contact/layout-05";


const DentalServicePage = ({ pageContext, location, data }) => {
    const content = normalizedData(data?.page?.content || []);
    const globalContent = normalizedData(data?.allGeneral.nodes || []);
    const { t } = useTranslation();

    return (
        <Layout location={location}>
            <Seo title="Services" />
            <Header
                data={{
                    ...globalContent["header"],
                    ...globalContent["menu"],
                }}
            />
            <main className="site-wrapper-reveal">
                <PageHeader
                    pageContext={pageContext}
                    location={location}
                    title= {t("Services")}
                />
                <DentalServiceArea
                    data={{
                        ...content["dental-service-section"],
                        items: data.allDentalService.nodes,
                    }}
                />
                <ContactArea data={content["contact-section"]} />
            </main>
            <Footer data={{ ...data.site.siteMetadata }} />
        </Layout>
    );
};

export const query = graphql`
    query DentalServicePageQuery($locale: String!) {
        allGeneral(filter: { locale: { eq: $locale } }) {
            nodes {
                section
                ...HeaderOne
            }
        }
        site {
            ...Site
        }
        page(
            title: { eq: "dental-services" }
            pageType: { eq: "innerpage" }
            locale: { eq: $locale }
        ) {
            content {
                ...PageContent
            }
        }
        allDentalService(filter: { locale: { eq: $locale } }) {
            nodes {
                ...DentalServiceOne
            }
        }
    }
`;

DentalServicePage.propTypes = {
    pageContext: PropTypes.shape({}),
    location: PropTypes.shape({}),
    data: PropTypes.shape({
        allGeneral: PropTypes.shape({
            nodes: PropTypes.arrayOf(PropTypes.shape({})),
        }),
        site: PropTypes.shape({
            siteMetadata: PropTypes.shape({
                contact: PropTypes.shape({}),
            }),
        }),
        page: PropTypes.shape({
            content: PropTypes.arrayOf(PropTypes.shape({})),
        }),
        allDentalService: PropTypes.shape({
            nodes: PropTypes.arrayOf(PropTypes.shape({})),
        }),
    }),
};

export default DentalServicePage;
